import { displayName, useSession } from "@/api/session";
import { Button, Menu } from "@/components";
import { THEMES, type ThemeChoice } from "../theme/themes";
import { useThemeSwitcher } from "../theme/useThemeSwitcher";
import { useSignOut } from "../useSignOut";

/** Account menu: who is signed in, theme, settings and sign out. */
export function UserMenu({ compact }: { compact: boolean }) {
  const session = useSession();
  const { choice, choose } = useThemeSwitcher();
  const signOut = useSignOut();
  const name = displayName(session.user);
  return (
    <Menu.Root>
      <Menu.Trigger>
        <Button
          variant="ghost"
          icon="user"
          iconEnd={compact ? undefined : "chevronDown"}
          aria-label={compact ? `Account: ${name}` : undefined}
        >
          {compact ? undefined : name}
        </Button>
      </Menu.Trigger>
      <Menu.Popup align="end">
        <Menu.Group label={`Signed in as ${session.user.username}`}>
          <Menu.LinkItem to="/settings" icon="settings">
            Settings
          </Menu.LinkItem>
        </Menu.Group>
        <Menu.Separator />
        <Menu.RadioGroup<ThemeChoice> label="Theme" value={choice} onValueChange={choose}>
          {THEMES.map((theme) => (
            <Menu.RadioItem key={theme.id} value={theme.id} icon={theme.icon}>
              {theme.label}
            </Menu.RadioItem>
          ))}
          <Menu.RadioItem value="system" icon="monitor">
            Match system
          </Menu.RadioItem>
        </Menu.RadioGroup>
        <Menu.Separator />
        <Menu.Item icon="logOut" onClick={() => void signOut()}>
          Sign out
        </Menu.Item>
      </Menu.Popup>
    </Menu.Root>
  );
}
